module.exports = __webpack_public_path__ + "img/IMG_1931.90859dbf.jpg";